import React from 'react';
import { FiX, FiCheckCircle } from "react-icons/fi";

const PlanDetailsModal = ({ isOpen, onClose, plan }) => {
  if (!isOpen || !plan) return null;

  return (
    <div className="fixed inset-0 z-[150] flex items-center justify-center px-4">
      <div
        className="fixed inset-0 bg-black/60 transition-opacity"
        onClick={onClose}
      />
      <div className="bg-white rounded-[12px] w-full max-w-[550px] relative z-[160] overflow-hidden shadow-2xl animate-in fade-in zoom-in duration-300">
        {/* Header Section */}
        <div className="bg-[#D7EAFF] p-4 md:p-6 flex justify-between items-center border-b border-[#E0E0E0]">
          <div className="pr-2">
            <h2 className="text-[18px] md:text-[22px] font-bold text-[#333] font-inter leading-tight">
              {plan.title}
            </h2>
            <p className="text-[12px] md:text-[14px] text-[#33333399] font-medium font-inter">
              Complete feature breakdown for {plan.validity}
            </p>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-white flex items-center justify-center text-gray-500 hover:text-red-500 transition-colors shadow-sm shrink-0"
          >
            <FiX size={20} className="md:size-24" />
          </button>
        </div>

        <div className="p-5 md:p-8 max-h-[50vh] md:max-h-[60vh] overflow-y-auto custom-scrollbar font-inter">
          <h3 className="text-[14px] md:text-[16px] font-bold text-[#333] mb-4 md:mb-6">
            What's included in this plan:
          </h3>

          <div className="space-y-3 md:space-y-4 text-left">
            {plan.features.map((feature, index) => (
              <div
                key={index}
                className="flex items-start gap-3 md:gap-4 p-2 rounded-[8px] border border-transparent hover:bg-gray-50 hover:border-gray-100 transition-all"
              >
                <FiCheckCircle className="text-[#21C11E] text-lg md:text-xl shrink-0 mt-0.5" />
                <div>
                  <p className="text-[13px] md:text-[15px] font-bold text-[#333] mb-0.5 md:mb-1">
                    {feature}
                  </p>
                  {/* <p className="text-[11px] md:text-[13px] text-gray-500 leading-tight">
                    Get full access with detailed explanations and performance tracking.
                  </p> */}
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Footer Section */}
        <div className="p-4 md:p-6 border-t border-gray-100 bg-gray-50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-center sm:text-left w-full sm:w-auto">
            <p className="text-[10px] md:text-[12px] text-gray-400 font-bold uppercase tracking-wider">Total Price</p>
            <span className="text-[20px] md:text-[24px] font-bold text-[#4096F6]">₹{plan.price}</span>
          </div>
          <button
            className="w-full sm:w-auto bg-[#4096F6] text-white px-8 md:px-10 py-3 rounded-[8px] font-bold text-[14px] md:text-[16px] hover:bg-[#2563EB] transition-all shadow-md active:scale-95"
            onClick={onClose}
          >
            Proceed to Payment
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlanDetailsModal;